(function($) {

    elementScale(); 

    $( window ).resize(function() { 
        elementScale();
    });

    // height
    function elementScale() {
        htmlHeight = $('html').height();

        if ($(window).width() >= 1450) {
            bodyHeight = 1100;
            windowHeight = 1100;
        } else {
            bodyHeight = 900;
            windowHeight = 900;
        }

        if ($(window).height() > windowHeight) {
            scale = 1
        } else {
            scale = htmlHeight / bodyHeight; 
        }

        $('.js-scale-container').css('transform', 'scale(' + scale + ')');
    }

}(jQuery));
